import EnumSet from 'Services/enumSet'

interface IOpportunitySortTypes extends EnumSet {
  expiresSoon: number,
  requestDate: number,
}

const OpportunitySortType = new EnumSet({
  expiresSoon: { value: 0, description: 'Encerram em breve' },
  requestDate : { value: 1, description: 'Data do pedido' },
}) as IOpportunitySortTypes

export default OpportunitySortType